// extracted by mini-css-extract-plugin
module.exports = {"container":"oTags_container__sPmqj","section":"oTags_section__kwqJ6","tags":"oTags_tags__616ZZ","tag":"oTags_tag__Tf98M"};